/*
 *   File : header.js
 *   Author : https://evoqins.com
 *   Description : Header component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';

// custom components
import { Icon } from '../Icon';
import { Modal } from 'bootstrap/dist/js/bootstrap.min';
import { ChangePasswordModal } from '../Modal';
import { OverLay } from '../Others';
import { APIService } from '../../Service';

const Header = (props) => {
    const lastPath = useRef(null);

    const PROFILE_DATA = useSelector((store) => store.Reducer.PROFILE_DATA);

    const navigate = useNavigate();
    const location = useLocation();

    const [menuModal, setMenuModal] = useState(false);
    const [menu, setMenu] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);

    useEffect(() => {
        if (menuModal === true) {
            const menu_modal = new Modal(document.getElementById('menu-modal'));
            menu_modal.show();
        }
    }, [menuModal]);

    useEffect(() => {
        _handleBackdrop();
        // Add the event listener
        window.addEventListener('popstate', _handleBackdrop);
        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('popstate', _handleBackdrop);
        };
        //eslint-disable-next-line
    }, []);


    useEffect(() => {
        if (lastPath.current === location.pathname) return;

        lastPath.current = location.pathname;
        _notificationCount();
    }, [location.pathname]);

    // handle back browser
    function _handleBackdrop() {
        setMenuModal(false);
        if (document.querySelector(".modal-backdrop")) {
            document.querySelector(".modal-backdrop").remove();
            document.body.style.overflow = 'unset';
        };
    };

    // handle menu
    const _handleMenu = () => {
        setMenu(!menu);
    };

    // handle change password 
    const _handleChangePassword = () => {
        setMenuModal(true);
        setMenu(false);
    };

    // handle notification
    const _handleNotification = () => {
        navigate('/notifications', {
            state: {
                notification_count: notificationCount,
                mark_as_read: true
            }
        })
    };

    // handle logout
    const _handleLogout = () => {
        Cookies.remove("access_token", {
            path: '/',
            domain: process.env.REACT_APP_ENV_DOMAIN,
        });
        window.location.replace("/");
    };

    // API - Notification count
    const _notificationCount = () => {
        let is_post = false;
        let url = 'notification/count';
        let request = {}
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setNotificationCount(response.data.notification_count);
            } else {
                setNotificationCount(0);
            }
        });
    };


    return (
        <>
            <div className='d-flex justify-content-between align-items-center e-bg-lavender px-3 padding-36px-tb'>
                <div>
                    <Icon icon='harmburger'
                        size="1.5rem"
                        className="d-flex cursor-pointer"
                        onClick={props.handleToggle} />
                </div>
                <div className='d-flex align-items-center gap-32px'>
                    {
                        Object.keys(PROFILE_DATA).length ?
                            <p className='mb-0'>{PROFILE_DATA?.email}</p>
                            : null
                    }

                    <div className='position-relative'
                        onClick={_handleNotification}>
                        <Icon icon='notification'
                            size="1.5rem"
                            className="d-flex cursor-pointer" />
                        {notificationCount !== 0 &&
                            <span className="position-absolute top-4px cursor-pointer left-70-per translate-middle badge rounded-pill e-bg-fire-engine-red e-text-white e-font-font e-font-8 e-font-weight-600 line-height-8px padding-3px-lr padding-5px-tb w-20px h-20px d-flex align-items-center justify-content-center"
                            >
                                {notificationCount > 99 ? '99+' : notificationCount}
                            </span>
                        }
                    </div>
                    <div className='position-relative'>
                        <Icon icon='menu'
                            size="1.5rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleMenu} />
                        {menu &&
                            <>
                                <OverLay isOpen={menu} onClose={_handleMenu} />
                                <div className="w-155px position-absolute end-0 top-40px e-bg-white border-radius-4 padding-10px-tb padding-16px-lr z-index-99 d-flex gap-20px flex-column">
                                    <div className="d-flex align-items-center">
                                        <Icon icon='change-password'
                                            size='1rem'
                                            className='d-flex' />
                                        <div onClick={_handleChangePassword}
                                            className='ps-2 e-primary-font e-font-weight-600 e-font-12 line-height-16px e-text-raisin-black cursor-pointer '>Change Password</div>
                                    </div>
                                    <div className="d-flex align-items-center cursor-pointer"
                                        onClick={_handleLogout}>
                                        <Icon icon='logout'
                                            size='1rem'
                                            className='d-flex'
                                        />
                                        <div className='ps-2 e-primary-font e-font-weight-600 e-font-12 line-height-16px e-text-raisin-black cursor-pointer'>Logout</div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>

            {
                menuModal === true &&
                <ChangePasswordModal
                    handleClose={() => {
                        setTimeout(() => {
                            setMenuModal(false);
                        }, 200);
                    }} />
            }
        </>
    )
}

export default Header;
